<template>
    <div>
        <container :active_path="path" :plate="'投资军团'">

            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="活动名称">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="活动日期">
                            <el-date-picker
                                v-model="form.date"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="form.putaway" placeholder="请选择" size="mini">
                                <el-option label="上架中" :value="true"></el-option>
                                <el-option label="已下架" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="search">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="add">添加活动</el-button>
                        </el-form-item>
                    </el-form>
                    
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tabledata" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="name" label="活动名称" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="stardate" label="活动时间" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="applydate" label="截止报名时间" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="click" label="报名人数" align="center"></el-table-column>
                        <el-table-column prop="tutorname" label="导师" align="center" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="putaway" label="状态" align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.putaway">上架</span>
                                <span class="text-danger" v-else>下架</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="报名用户" align="center">
                            <template slot-scope="s">
                                <span class="btn-text link-text" @click="singinuser(s.row)">报名用户</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="click" label="操作" width="236">
                            <template slot-scope="s">
                                <el-button type="warning" v-if="s.row.putaway" size="mini" @click="putaway(s.row)">下架</el-button>
                                <el-button type="success" v-if="!s.row.putaway" size="mini" @click="putaway(s.row)">上架</el-button>
                                <el-button type="danger" size="mini" @click="del(s.row)">删除</el-button>
                                <el-button type="primary" size="mini" @click="edit(s.row)" plain>编辑活动</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>

        </container>
        <router-view></router-view>
    </div>
</template>

<script>
import container from '../../../components/container.vue'
export default {
    components: { container },
    data() {
        return {
            path: '/invest/activity',
            form: {
                name: '',
                date: [],
                putaway: '',
            },
            pageNo: 1,
            pagesize: 14,
            total: 0,
            tabledata: [],
        }
    },
    mounted () {
        this.getTableData();
    },
    methods: {
        singinuser(item) {
            this.$router.push({path: '/invest/activity/apply', query: {id: item._id['$oid']}})
        },
        putaway(row) {
            var id = row._id['$oid'];
            var params = {
                id,
                putaway: !row.putaway
            }
            this.$api.putAwayActivity(params).then(
                data=>{
                    this.$message.success(data);
                    this.getTableData();
                }
            )
        },
        del(row) {
            this.$confirm('是否确定删除'+row.name).then(
                confirm=>{
                    var id = row._id['$oid'];
                    var params = {
                        id,
                    }
                    this.$api.deleteActivity(params).then(
                        data=>{
                            this.$message.success(data);
                            this.getTableData();
                        }
                    )
                },
                cancel=>{}
            )
        },
        edit(row) {
            var id = row._id['$oid']
            this.$router.push({path: '/invest/activity/edit', query: {id}})
        },
        getTableData() {
            var params = {
                name: this.form.name,
                date: JSON.stringify(this.form.date),
                putaway: this.form.putaway,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getActivityList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tabledata  = list;
                    this.total = total;
                }
            )
        },
        search() {
            this.pageNo = 1;
            this.getTableData();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
        add() {
            this.$router.push({path: '/invest/activity/add'})
        },
    },
    beforeRouteUpdate(to, from, next) {
        if (from.path=="/invest/activity/add"||from.path=="/invest/activity/edit"){
            this.getTableData();
        }
        next();
    },
}
</script>

<style lang="scss" scoped>

</style>